// if (!customElements.get('show-more-button')) {
//   customElements.define(
//     'show-more-button',
//     class ShowMoreButton extends HTMLElement {
//       constructor() {
//         super();
//         const button = this.querySelector('button');
//         button.addEventListener('click', (event) => {
//           this.expandShowMore(event);
//           const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item');
//           if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden') && nextElementToFocus.querySelector('input')) {
//             nextElementToFocus.querySelector('input').focus();
//           }
//         });
//       }
//       expandShowMore(event) {
//         const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
//         const parentWrap = parentDisplay.querySelector('.parent-wrap');
//         this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
//         parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));
//         if (!this.querySelector('.label-show-less')) {
//           this.classList.add('hidden');
//         }
//       }
//     }
//   );
// }
if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();

        const button = this.querySelector('button');

        if (!button) return;

        button.addEventListener('click', (event) => {
          this.expandShowMore(event);

          const parentDisplay = event.target
            .closest('.parent-display');

          const nextElementToFocus = parentDisplay?.querySelector(
            '.show-more-item'
          );

          if (
            nextElementToFocus &&
            !nextElementToFocus.classList.contains('hidden') &&
            nextElementToFocus.querySelector('input')
          ) {
            nextElementToFocus.querySelector('input').focus({
              preventScroll: true
            });
          }
        });
      }

      expandShowMore(event) {
        const parentDisplay = event.target
          .closest('[id^="Show-More-"]')
          .closest('.parent-display');

        if (!parentDisplay) return;

        // Existing functionality
        this.querySelectorAll('.label-text').forEach((element) => {
          element.classList.toggle('hidden');
        });

        parentDisplay
          .querySelectorAll('.show-more-item')
          .forEach((item) => {
            item.classList.toggle('hidden');
          });

        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }

        /*
         * ONLY this Show More's parent-display
         * will be searched.
         *
         * We NEVER search parent elements outside
         * this parentDisplay.
         */
        requestAnimationFrame(() => {
          const scrollableElements = [
            parentDisplay,
            ...parentDisplay.querySelectorAll('*')
          ];

          let scrollElement = null;

          for (const element of scrollableElements) {
            const style = window.getComputedStyle(element);

            const canScroll =
              /(auto|scroll)/.test(style.overflowY) &&
              element.scrollHeight > element.clientHeight;

            if (canScroll) {
              scrollElement = element;
              break;
            }
          }

          /*
           * Scroll ONLY the internal element belonging
           * to this Show More.
           */
          if (scrollElement) {
            scrollElement.scrollTop = 0;
          }
        });
      }
    }
  );
}

